export enum ProductCategoryType {
    Propane = 1,
    Tank = 2,
    Service = 3,
    Fee = 5,
    Other = 4
}